import { Reports } from "./../../services/reports";

export const state = {
  neighborhoods: [],
  statuses: [],
  citiesStatuses: []
};

export const mutations = {
  SET_NEIGHBORHOODS(state, neighborhoods) {
    state.neighborhoods = neighborhoods;
  },
  SET_STATUSES(state, statuses) {
    state.statuses = statuses;
  },
  SET_CITIES_STATUSES(state, citiesStatuses) {
    state.citiesStatuses = citiesStatuses;
  }
};

export const actions = {
  getNeighborhoodStatus({ commit }) {
    return Reports.getNeighborhoodStatus()
      .then(response => {
        commit("SET_NEIGHBORHOODS", response.data);
        return response;
      })
      .catch(error => error);
  },
  getStatuses({ commit }) {
    return Reports.getStatuses()
      .then(response => {
        commit("SET_STATUSES", response.data);
        return response;
      })
      .catch(error => error);
  },
  getCitiesStatuses({ commit }) {
    return Reports.getCitiesStatuses()
      .then(response => {
        commit("SET_CITIES_STATUSES", response.data);
      })
      .catch(error => error);
  }
};
